<template>
  <div class="c-field">
    <slot v-if="$slots.label" name="label" />
    <label class="c-field-label" v-else>{{ label }}</label>

    <div class="mt-2">
      <slot v-if="$slots.value" name="value" />
      <span class="c-field-value">{{ value }}</span>
    </div>
  </div>
</template>

<script setup lang="ts">
defineOptions({
  name: 'Field',
});

defineProps({
  label: {
    type: String,
  },
  value: null,
});
</script>
